import { SET_REAC, SET_REAC_DATA, DELETE_REAC, SET_REAC_LOADING } from '../../../actions';
import toPairs from 'lodash.topairs';
import omit from 'lodash.omit';

export const reacondicionados = (state = {}, action) => {
    switch (action.type) {
        case SET_REAC_DATA:
            return { ...state, loading: false, data: action.payload };
        case SET_REAC: {
            const { id, data } = action.payload;
            return { ...state, data: { ...state.data, [id]: data } };
        }
        case DELETE_REAC: {
            const { id } = action.payload;
            return { ...state, data: omit(state.data, [id]) };
        }
        case SET_REAC_LOADING: {
            const { loading } = action.payload;
            return { ...state, loading };
        }
        default:
            return state;
    }
};

const fromObjToArray = data => toPairs(data).map(([key, value]) => ({ ...value, id: key }));
export const getReacData = reac => fromObjToArray(reac);
